export default {
  chats: null,
  chat: null,
  clientTableFilters: null,
  lenderPortfolio: null,
  projectPortfolio: null,
  clientTableDataLoading: true,
  saving: false,
  unreadNotifications: null,
  mtgAppValidating: false,
  reviewMode: false,
  errorLocations: [], // work in progress to save error element ids for user to jump through
  dirtyData: null,
  appAppErrors: {},
  ociValidationSchema: [],
  lawyerClientData: null,
  lawyerAssignedList: null,
  lawyerRepList: null,
  lawyerFirmRep: null,
  gdsCalculation: null,
  tdsCalculation: null,
  loanApplicationLenders: null,
  projectLenders: null,
  conditionSets: null,
  activityEvents: null,
  ociAnalytics: null,
  projectUploadColumns: null,
  lenderAnalytics: null,
  lenderPage: null,
  lawyerPage: null,
  lenderClientDataData: null,
  purchaserDetails: null,
  mostRecentCampaignsStatus: null,
  lenderCriteriaResults: null,
  projectCodes: null,
  eventsByLoanId: null,
  // activeClient: null,
  activeApplicant: null,
  // coApplicantApplicationApplicantId: 0,
  // coApplicantApplicantRelationship: "",
  activeMessage: {message: 'No data'},
  edsFunding: 0,
  purchasePriceSum: 0,
  purchasePriceSumAwareness: 0,   //variable to hold all purchase prices for clients in awareness
  purchasePriceSumExploration: 0, //variable to hold all purchase prices for clients in exploration
  purchasePriceSumApproval: 0, //variable to hold all purchase prices for clients in approval
  // persons: [],
  applicants: [],
  selectedApplicants: [],
  applicant: {
    applicantId: 0,
    bankingBranchLocation: '',
    bankingBranchTransit: '',
    bankingLenderCode: '',
    bankingMonthsWithBank: '',
    bankruptcyAmount: '',
    bankruptcyDate: '',
    bankruptcyDischargeDate: '',
    bankruptcyReason: '',
    bankruptcyStatus: '',
    baseTaxIn: '',
    baseTaxOut: '',
    citizenship: '',
    cosignsAnotherLoan: '',
    creditBureaus: '',
    developerEmployeeNumber: '',
    dependantAges: '',
    guaranteesAnotherLoan: '',
    relationshipId: 0,
    //includeIncomeInRatios: '',
    lenderEmployeeNumber: '',
    personProfile: {
      profileId: '',
      maritalStatus: '',
      birthdate: '',
      monthsInCommunity: 0,
      sinSSN: '',
      spouse: '',
      name: {
        nameId: 0,
        firstName: '',
        lastName: '',
        prefix: '',
      },
      phones: [{
        active: '',
        extension: '',
        number: '',
        phoneGroup: '',
        phoneId: '',
        phoneType: '',
        phoneVerified: '',
        // primary:'',
        smsVerified: '',
      }],
      emails: [{
        emailAddress: '',
        emailGroup: '',
        emailVerified: '',
        // primary: '',
        type: ''
      }],
      addresses: [
        {
          addressId: 0,
          streetAddr1: '',
          streetAddr2: '',
          addressType: '',
          city: '',
          provinceState: '',
          country: '',
          postalZipCode: '',
        }
      ],
    },
    employments: [{
      employmentId: 0,
      employmentStatus: '',
      companyName: '',
      occupation: '',
      monthsInOccupation: '',
      address: {
        addressId: 0,
        streetAddr1: '',
        city: '',
        country: '',
        provinceState: '',
      },
      income: {
        incomeId: 0,
        incomeType: "",
        annualIncome: "",
      },
    }],
    otherIncomes: [{
      otherIncomeId: 0,
      incomeType: '',
      netAnnualIncome: '',
      durationMonths: null
    }],
    assets: [{
      assetType: '',
      assetTotalValue: '',
      assetDescription: '',
      vehicleType: '',
      vehicleMake: '',
      vehicleModel: '',
      vehicleYear: '',
      otherProperty: '',
      assetLiabilities: [],
    }],
    liabilities: [{
      liabilityAccountNumber: '',
      liabilityLoanEstimatesDebt: '',
      liabilityMortgageType: '',
      liabilityType: '',
      liabilityTotalDebt: '',
      liabilityDescription: '',
      liabilityLender: '',
      liabilityCreditCardType: '',
      liabilityCreditHighLimit: '',
      vehicleLoanType: '',
      liabilityMonthlyPayment: '',
    }],
  },
  brokerProjects: [],
  applicationApplicant: {
    applicationApplicantId: 0,
    applicationReferenceCode: '',
    includeIncomeInRatios: false,
    realtionshipToApplicant: '',
    occupantOfDwelling: false,
    clientType: '',
    applicant: {},
    loanApplication: {
      loanApplicationId: 0,

    },
    onTitle: false
  },
  clientsData: [],//State to hold data for the client management table
  clientStats: [],//State to hold data for client mgmt stat cards
  firms: [],
  firmsByType: [],
  firm: {
    firmType: '',
    brandLegalName: '',
    brandLegalNumber: '',
    brandAlias: '',
    firmName: '',
    brokerageLicenseNumber: '',
    address: {
      streetAddr1: '',
      city: '',
      provinceState: '',
      country: '',
      latitude: 0,
      longitude: 0,
      code: '',
      addressType: '',
      postalZipCode: '',
    },
    firmRepresentatives: [{
      representativeRole: '',
      brokerLicense: '',
      personProfile: {
        profileId: null,
        name: {
          firstName: '',
          lastName: '',
        },
        phones: {
          areaCode: '',
          number: '',
          //isPrimary: '',
          phoneGroup: ''
        },
        emails: {
          emailAddress: '',
          emailGroup: ''
        }
      }
    }],
    firmEmails: [{
      emailId: '',
      emailAddress: '',
      emailGroup: '',
      isPrimary: '',
      emailVerified: ''
    }],
    projects: [{
      firmProfileId: '',
      actualRegistrationDate: '',
      address: {
        streetAddr1: '',
        city: '',
        provinceState: '',
        country: '',
        latitude: 0,
        longitude: 0,
        code: '',
        addressType: '',
        postalZipCode: '',
      },
      plannedRegistrationDate: '',
      projectId: '',
      projectName: '',
      projectNumberOfUnits: '',
      projectSize: '',
      projectCode: '',
      status: '',
      subMarket: '',
      uploadedByUser: '',
      uploadedDateTime: ''
    }],
  },
  projects: [],
  firmRepsWithUserInfo: [],
  activeFirm: null,
  project: {
    projectName: '',
    projectSize: '',
    projectNumberOfUnits: '',
    plannedRegistrationDate: '',
    actualRegistrationDate: '',
    subMarket: '',
    address: {
      streetAddr1: '',
      city: '',
      provinceState: '',
      country: '',
      latitude: '',
      longitude: '',
      code: '',
      addressType: '',
      postalZipCode: '',
    },
    firmProfile: {
      firmProfileId: ''
    }
  },
  enrollmentPhase: 'initial', // other states can be uploaded, validation,summary,
  /*person: {
    profileId: null,
    name: {
      nameId:0,
      firstName: '',
      lastName: '',
    }
  },*/
  firmRep: {
    firmRepId: '',
    representativeRole: '',
    brokerLicense: '',
    representativeStatus: '',
    personProfile: {
      name: {
        firstName: '',
        lastName: '',
      },
      phones: {
        areaCode: '',
        number: '',
        //isPrimary: '',
        phoneGroup: ''
      },
      emails: {
        emailAddress: '',
        emailGroup: ''
      }
    },
    userRoles: [],
    username: '',
    firmProfile: {
      firmProfileId: ''
    }
  },
  messages: [],// for list of messages in lender/Admin page
  messageType: null, // for displaying message by MessageType
  type: null,

  //Auth and Session
  sessionInfo: null,
  authResponse: null,
  //This stores the info for the logged in user, after de-coding the jwt token user token from backend
  // This data should only be set when user logs in. Note you can get the associated person profile using profileId to fetch from backend.
  appUser: {
    firstName: '',
    lastName: '',
    userId: 0,
    roles: [],
    profileId: 0,
    exp: 0,
    iat: 0,
    firmProfileId: '',
    firmName: 0,
    firmDomain: '',
    firmRepId: 0,
  },
  //Used to maintain the user -token from backend in global state
  userToken: sessionStorage.getItem('ocu') || '',
/// used to store the status of the user
  userStatus: '',
  purchasePrice: '',// for displaying average purchasePriceTaxOut
  messageDiction: {},// for displaying message by MessageType
  msgTypeArray: [], // for fetching messages in lender/Admin page
  filterActiveMessages: [], // for list of active messages in lender/Admin page
  filterInactiveMessages: [], // for list of inactive messages in lender/Admin page
  activeWealthSaverConfig: {},//for wealth saver config in project profile page
  applicantByProfile: {},
  projectAsset: {},
  //projectAsetByApplicant is for the loadProjectAssetByAPplicantId but returns a application applicant
  projectAssetByApplicant: { //for getting projectAssetDetails based on consideration type that is dwelling or parking etc
    loanApplication: {
      conditions: '',
      lenderSubmissions: '',
      loanApplicationId: 0,
      mortgage: '',
      projectAssets: [{
        considerationType: ''
      }],
    },
  },
  //the purchase price of the project asset is found using the applicant id in actions
  projectAssetPurchasePrice: 0,
  authPermissions: {
    purchaserDashboardMenu: ['super', 'purchaser'],
    lenderDashboardMenu: ['super', 'lender'],
    developerDashboardMenu: ['super', 'developer'],
    ociDashboardMenu: ['super', 'oci_broker'],
    adminDashboardMenu: ['super'],
    adminMenu: ['super'],
    userActivityTopRightMenu: ['super', 'lender', 'oci'],
    partnerDashboardMenu: ['super', 'partner']
  },
  previousRoute: '',
  authTest: 'test',
  userHome: '',
  userRedirect: '',
  availableGroupRoles: [],
  file: {},
  fileUploaded: false,
  documents: [],// for list of documents from s3 bucket
  conditionDocuments: [],
  activeApplicationApplicant: {
    applicationApplicantId: 0,
    applicationReferenceCode: 0,
    applicant: {},
    clientType: '',
    includeIncomeInRatios: '',
    loanApplication: null,
    occupantOfDwelling: '',
    onTitle: '',
    relationshipToApplicant: '',
  },
  //Object for an applicationHistory
  applicationHistory: {
    date: null,
    appUser: null,
    handler: {},
    hibernateLazyInitializer: {},
    applicationStatuses: {},
    loanApplication: {}
  },
  //State to hold a list of application histories
  applicationHistories: [],
  applicationHistoryDetails: [],//get list of application history
  applicationStatus: '',
  //Main applicants assets
  assetValue: 0,
  //Co-appliucant assets
  coApplicantAssets: 0,
  //Bank loans, credit cards and LOC's
  liabilitiesValue: 0,
  //This is the liabilities inside the ApplicantAssets;property LOC's, vehicle loans, and property mortgages
  otherLiabilities: 0,
  errorNotification: {},
  purchaserChat: null, // a purchaser only has one chat
  purchaserChatMessages: [], //messages for the single purchaser chat
  userChats: [], //list of all chats in which user participates
  purchaserChats: [], //broker uses several purchaser chats
  currentChatMessages: [], // used as a container of chatMessages for current chat previous archived messages
  currentNotifications: [],// all notifications which are within the start and end period for displaying
  notificationHistoryDisplay: false,
  purchaserChatRequestComplete: false,
  brokerChatPageOpen: false,
  brokerMiniChatOpen: false,
  monthlyRent: [{
    amount: 0,
  }],
  occupancyType: "",
  BOCRate: 1,
  recentApplications: [],
  allApplicationApplicants: null, // Editable array of applicants
  allApplicationApplicantsInitial: null, // Initial copy from database
  showSideBar: false,
  //Data Loading Status
  activeApplicationApplicantLoading: false,
  allApplicationApplicantsLoading: false,
  uploadedFileURL: "",
  personProfileLoading: false,
  lenderResponses: [],
  lenderSubmitResponses: [],
  lenderSubmissions: [],
  pagination: {
    perPage: 12,
    currentPage: 1,
    perPageOptions: [12, 24, 48, 96],
    total: 0,
    sortProp: 'lotNum',
    sortOrder: 'ASC',
    searchParameter: {
      firmID: '1',
      projectName: '',
      status: '',
      clientType: '',
      lender: '',
      maxPurchasePrice: '',
      minPurchasePrice: '',
      lotNum: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      applicationCode: '',
      applicantCode: '',
      sortProp: ''
    }
  },
  prospectorClientsData: [],
  selectedProject: '',
  projectsByFirm: [],
  projectUploadDataLoading: true,
  projectPerformance: [],
  showApplicant: [{
    index: 0,
    show: true,
  }],
  applicantsCount: 0,
  newApplicants: [],
  findApplicants: {
    applicants: null,
    searched: false
  },
  loanApplicationNewApplicants: null,
  bureauRequestedRetrieved: false,
  mortgageApplicationRefresh: false,
  // promptMtgAppSave: false,
  creditBureauMatchIndicator: null,
  appApplicantHistory: [],
  appApplicantHistoryLoading: false,
  pdfFileName: null,
  appApplicantConsentStatus: null,
  ociAppMessage: null,
  sendMarketingEmail: [],
  sendBrokerEmailNotification: {},
  campaigns: [],
  activeCampaign: null,
  campaignsByProject: [],
  campaignsByFirm: [],
  campaignsPaginated: null,
  /**
   * Global Api Error Message
   *  Example response from backend of OciAppError object
   *  {"ociTimestamp":"19-03-2019 07:39:50",
   *  "ociErrorIdentifier":"110896",
   *  "ociStatusCode":400,
   *  "ociStatus":"BAD_REQUEST",
   *  "ociMessage":"The parameter 'id'  could not be converted to type 'Long'",
   *  "ociDebugMessage":null}
   */
  error: null,
  // Used to suppress global display of error messages in order to handle it on component level.
  // Mutation to change to true should be done in created hook of parent component of page
  suppressGlobalErrorMessage: false,
  success: false,
  saveStatus: null,
  withinMortgageApp: false,
  projectName: null,
  editedClientsData: [],
  purchaserConsentUpdated: false,
  restrictedEmailAddress: false, // to check whether the emailId is un-subscribed or blocked
  marketingClientData: {},
  providerToken: null,
  additionalFinancialServiceInterestDetails: {}, // for getting additionalFinancialServiceInterestDetails fields
  appApplicantHistoryByLoanApplication: [], // for getting appApplicantHistory by LoanApplicationId
  wealthSaverAmount: {},//for getting wealth saver by ClientToken for Purchaser
  wealthSaverAmtByAppAppId: {},//for getting wealth saver by AppApplicantId
  profileByUser: {},
  applicantSearchLoading: false,
  applicantConsentLoading: false,
  lendingCriteriaFilters: [],
  creditorInsuranceRequests: [],
  creditorInsuranceLoading: false,
  conditionSet: [],
  condition: {},
  activeCondition: {},
  conditions: [],
  conditionUploadStatus: null,
  conditionsLoading: false,
  applicationConditions: [],
  applicationConditionSet: [],
  applicationConditionsLoading: false,
  conditionsByFirmType: [],
  sendPurchaserConditions: null,
  documentStatus: {},
  profilePicture: null,
  campaignsLoading: false,
  loanApplicationsByProject: [],
  invoiceFormData: null,
  invoiceList: null,
  invoicing: {},
  generatedInvoices: [],
  borrowersDisclosureFormData: null,
  projectsByProfile: [],
  applicationStatusByAppApplicant: {},
  purchaserApplicationConditions: [],
  fileScanning: null,
  firmRepEmail: null,
  purchaserActivity: [],
  purchaserFlow: null,
  purchaserFlows: null,
  purchaserData: null,
  clientToken: null,
  purchaserMessage: null,
  lenderProjectNames: [],
  confirmEmailSent: true,
  requestedApplicationConditions: [],
  prospectInfo: null,
  profileByRole: [],
  salesPageView: false,
  followups: [],
  followupsLoading: false,
  apiResponse: null,
  notificationAcknowledgement: false,
  userNotificationSettings: [],
}
